import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { ErrorStackService } from './error-stack.service';

@Injectable()
export class StorageS3HttpMethodsService {

  constructor(private http: HttpClient, 
    private errorStack: ErrorStackService) { }

  ls(accessKeyId, secretAccessKey, bucket, path): Promise<any> {
    const self = this;
    return new Promise((resolve, reject) => {
      let params = new HttpParams().
      set('path', btoa(path)).
      set('bucket', btoa(bucket)).
      set('accessKeyId', btoa(accessKeyId)).
      set('secretAccessKey', btoa(secretAccessKey))
      ;

      //self.http.get('https://hsbwinservices.tk/api/v2/io/s3/ls', {params: params})
      self.http.get('https://automation.hsbservices.com/api/v2/io/s3/ls', {params: params})
      .subscribe(data => {
            resolve(data);
      }, error => {
          self.errorStack.append(error, true);
          reject(error);
      });
    });
  }
  listBuckets(accessKeyId, secretAccessKey) : Promise<any>{
    
    return new Promise((resolve, reject) => {
      let params = new HttpParams().
      set('accessKeyId', btoa(accessKeyId)).
      set('secretAccessKey', btoa(secretAccessKey));

      //this.http.get('https://hsbwinservices.tk/api/v2/io/s3/listbuckets', {params: params})
      this.http.get('https://automation.hsbservices.com/api/v2/io/s3/listbuckets', {params: params})
      .subscribe(data => {
            resolve(data);
      }, error => {
          this.errorStack.append(error, true);
          reject(error);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/storage-s3-http-methods.service.ts